getInternalParamsState